export const searchUsersSiteCoreKeys = {
  contains: "FilterBy.Contains",
  usersHeader: "PermissionAndMessages.Users.UsersHeader",
  addUserButton: "Users.UsersHeader.AddUserButton",
  searchUsers: "PermissionAndMessages.Users.SearchUsers",
  roleLabel: "Users.SearchUsers.Role",
  serviceOffice: "Users.SearchUsers.ServiceOffice",
  userEmailID: "Users.SearchUsers.UserEmailID",
  userName: "Users.SearchUsers.UserName",
  userStatus: "Users.SearchUsers.UserStatus",
  filterByList: "Users.SearchUsers.FilterByList",
  statusList: "Users.SearchUsers.StatusList",
};

export const searchUsersResultsSiteCoreKeys = {
  results: "PermissionAndMessages.Users.Results",
  allUsersHeader: "Users.Results.AllUsersHeader",
  userName: "Users.Results.UserName",
  userEmail: "Users.Results.UserEmail",
  roleLabel: "Users.Results.Role",
  countryLabel: "Users.Results.Country",
  serviceOffice: "Users.Results.ServiceOffice",
  userMobileNumber: "Users.Results.UserMobileNumber",
  userStatus: "Users.Results.UserStatus",
  createdDate: "Users.Results.CreatedDate",
  actionLabel: "Users.Results.Action",
  selectedRoles: "Users.Results.SelectedRoles",
  selectedCountry: "Users.Results.SelectedCountry",
  selectedServiceOffice: "Users.Results.SelectedServiceOffice",
  statusList: "Users.Results.StatusList",
};
